import { render, staticRenderFns } from "./guest-footer.vue?vue&type=template&id=3acb2975&"
import script from "./guest-footer.vue?vue&type=script&lang=js&"
export * from "./guest-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports